import { useEffect } from "react";
import gsap, { Power2 } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const useImageParallax = (selector: string = ".anim-image-parallax") => {
  useEffect(() => {
    const elements = document.querySelectorAll<HTMLElement>(selector);

    elements.forEach((el) => {
      // Wrap div create karna
      if (!el.parentElement?.classList.contains("anim-image-parallax-inner")) {
        const wrap = document.createElement("div");
        wrap.classList.add("anim-image-parallax-wrap");

        const inner = document.createElement("div");
        inner.classList.add("anim-image-parallax-inner");

        el.parentNode?.insertBefore(wrap, el);
        wrap.appendChild(inner);
        inner.appendChild(el);
      }

      const wrap = el.closest(".anim-image-parallax-wrap") as HTMLElement;
      const inner = wrap.querySelector(
        ".anim-image-parallax-inner"
      ) as HTMLElement;

      wrap.style.overflow = "hidden";

      // Parallax effect
      gsap.to(el, {
        yPercent: 40,
        ease: "none",
        scrollTrigger: {
          trigger: wrap,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          markers: false,
        },
      });

      // Zoom in (without hiding image first)
      const tl_aipZoomIn = gsap.timeline({
        scrollTrigger: {
          trigger: wrap,
          start: "top 90%",
          markers: false,
        },
      });

      tl_aipZoomIn.fromTo(
        inner,
        { scale: 1.2 }, // starting slightly zoomed
        {
          duration: 1.5,
          scale: 1,
          ease: Power2.easeOut,
          clearProps: "all",
        }
      );
    });
  }, [selector]);
};
